module.exports = __webpack_public_path__ + "img/enterprise_refund.b3093bb8.svg";